import { createApp } from 'vue'
import { createPinia } from "pinia";
import { Notify, Quasar } from "quasar";
import router from "./router";
import deepState from "./utils/deepState";
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css';
import '@quasar/extras/mdi-v6/mdi-v6.css';
import 'quasar/src/css/index.sass';
import App from './App.vue';

export const pinia = createPinia();

const app = createApp(App);

app.use(router);
app.use(pinia);
app.use(deepState);

app.use(Quasar, {
    plugins: { Notify }, // import Quasar plugins and add here
});

app.mount('#app');
